import React from 'react';

/**
 * Badge Component
 * 
 * A reusable badge component styled according to Zamanat design system
 * 
 * @param {Object} props
 * @param {string} props.variant - Badge variant: 'primary', 'accent', 'success', 'warning', 'error'
 * @param {string} props.className - Additional CSS classes
 * @param {React.ReactNode} props.children - Badge content
 */
const Badge = ({
  variant = 'primary',
  className = '',
  children,
  ...props
}) => {
  const variantClasses = {
    primary: 'badge-primary',
    accent: 'badge-accent',
    success: 'badge-success',
    warning: 'badge-warning',
    error: 'badge-error',
    info: 'badge-info',
    default: 'badge-default',
    danger: 'badge-error',
  };
  
  const classes = [
    'badge',
    variantClasses[variant] || variantClasses.primary,
    className,
  ].filter(Boolean).join(' ');
  
  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
};

export default Badge;

